// dialog.tokens.ts
import { InjectionToken } from '@angular/core';

export const DRAWER_DATA = new InjectionToken<any>('DRAWER_DATA');